import axios from 'axios'
import {ElMessage} from 'element-plus'

// 创建一个 axios 实例
const request = axios.create({
	baseURL: import.meta.env.VITE_API_BASE_URL, // 替换为你的 API 基地址
	headers: {
		'Content-Type': 'application/json;charset=UTF-8', // 'Cache-Control': 'no-cache',
	}
})

// 响应拦截器
request.interceptors.response.use(response => {
	//接口返回数据，解密处理
	// if (import.meta.env.NODE_ENV === 'release') {
	// 	if (response.data.encryptInfo) {
	// 		const encryptInfo = response.data.encryptInfo
	// 			.replace(/\s+/g, "")
	// 			.replace(/<\/?.+?>/g, "")
	// 			.replace(/[\r\n]/g, "")
	// 			.replace(" ", "");
	// 		response.data = JSON.parse(AES.decrypt(encryptInfo))
	// 	} else {
	// 		let {data} = response
	// 		const responseData = JSON.parse(AES.decryptString(data))
	// 		return responseData.data
	// 	}
	// } else {
	// 	return response.data.data
	// }
	if (response.data.code >= 400) {
		if (response.config.silentBusinessError) {
			const error = new Error(response.data.message)
			error.code = response.data.code
			return Promise.reject(error)
		}
		return Promise.reject(ElMessage({
			message: response.data.message, customClass: 'dialog-message-font', grouping: true, type: 'error'
		}))
	}
	return Promise.resolve(response.data.data)
}, error => {
	return Promise.reject(error)
})

export default request
